export default {
  CONFIRM_PASSWORD: 'Conferma password',
  FORGOT_PASSWORD_CAPTION:
    "Nessun problema. Inserisci il tuo nome utente e condivideremo un link di reimpostazione sull'indirizzo e-mail registrato.",
  PASSWORD_EMAIL_SUCCESS: 'Una nuova password è stata inviata alla tua email.',
  SENT_EMAIL_TITLE: 'Nuova password inviata',
  INVALID_RESET_PASS_LINK: 'Il link della password non è valida. Riprova!',
  RESET_PASS_SUCCESS: 'Password modificata con successo, accedi.',
  RESET_PASS_LINK_EXPIRED: 'Il link per reimpostare la password è scaduto, riprova!',
  PASSWORDS_NOT_SAME: 'Le due password scritte devono coincidere.',
  RESET_PASSWORD: 'Reimposta password',
  RESET_PASSWORD_CAPTION: 'Inserire il proprio nome e cliccare su Invio:'
}
